import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import type { ThemeConfig } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App'
import './index.css'

// CrawlBox 设计规范主题 — 墨水书卷风：象牙白底 + 墨黑文字 + 琥珀点缀
const themeConfig: ThemeConfig = {
  token: {
    // 品牌与链接
    colorPrimary: '#B45309', // 琥珀色主按钮，书签般的点缀
    colorLink: '#B45309',   // 琥珀链接
    colorLinkHover: '#92400E',
    colorLinkActive: '#92400E',
    // 语义色
    colorSuccess: '#0D7D6C', // 青绿，已读/成功
    colorError: '#B91C1C',
    colorWarning: '#B45309',
    colorInfo: '#57534E',    // 暖灰，替代冷蓝
    // 文字三级
    colorText: '#1C1917',    // 墨黑
    colorTextSecondary: '#57534E', // 暖灰
    colorTextTertiary: '#A8A29E',
    colorTextQuaternary: '#D6D3CD',
    // 描边
    colorBorder: '#E7E5E0',
    colorBorderSecondary: '#EDE9E3',
    // 表面
    colorBgLayout: '#FAF8F5', // 象牙白背景
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    // 字体
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Inter', system-ui, 'PingFang SC', 'Microsoft YaHei', sans-serif",
    fontSize: 14,
    // 圆角
    borderRadius: 10,
    borderRadiusSM: 6,
    borderRadiusLG: 14,
    // 阴影仅用于浮层
    boxShadow: '0 1px 2px rgba(28,25,23,.04), 0 2px 8px rgba(28,25,23,.04)',
    boxShadowSecondary:
      '0 1px 2px rgba(28,25,23,.04), 0 2px 8px rgba(28,25,23,.04)',
  },
  components: {
    Layout: {
      headerBg: '#FFFFFF',
      bodyBg: '#FAF8F5', // 象牙白
      siderBg: '#FFFFFF',
    },
    Menu: {
      itemColor: '#57534E',
      itemHoverBg: '#FAFAF8',
      itemActiveBg: '#FAFAF8',
      itemSelectedBg: '#FAFAF8',
      itemSelectedColor: '#B45309', // 琥珀
      horizontalItemSelectedColor: '#B45309',
    },
    Tabs: {
      itemColor: '#57534E',
      itemHoverColor: '#1C1917',
      itemActiveColor: '#1C1917',
      itemSelectedColor: '#B45309',
      inkBarColor: '#B45309',
    },
    Radio: {
      buttonCheckedBg: '#B45309',
      buttonCheckedColor: '#FFFFFF',
      buttonSolidCheckedBg: '#B45309',
      buttonSolidCheckedColor: '#FFFFFF',
      buttonSolidCheckedHoverBg: '#92400E',
    },
    Card: {
      headerBg: 'transparent',
      paddingLG: 20,
    },
    Tag: {
      defaultBg: '#FAFAF8',
      defaultColor: '#78716C',
    },
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider locale={zhCN} theme={themeConfig}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
